import { SyncInventoryPresenter } from 'components/domain/inventory/SyncInventoryPresenter'
import { AppLayout } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { Redirect } from 'react-router-dom'

export const Inventory = (): JSX.Element => {
  const { user } = useUser()

  if (!user || user?.subscription.allFeaturesDisabled || !user.isTester?.ptInventory) {
    return <Redirect to="/" />
  }

  return (
    <AppLayout noDOMLayout>
      <SyncInventoryPresenter />
    </AppLayout>
  )
}
